import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
/** WHY: Double is a wordmark (non-square aspect 80:24). `size` is interpreted as height;
 * width scales proportionally so the chip renders it at ~80x24 when size=24. */ export const DoubleIcon = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        width: size * 80 / 24,
        height: size,
        viewBox: "0 0 80 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        style: style,
        className: className,
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M48.4313 4V9.57193C50.1549 7.86569 53.2723 7.7124 55.4755 8.73214C59.6421 10.6517 60.1667 16.0703 56.5771 18.703C54.254 20.4025 50.3273 20.5158 48.274 18.403V19.7294H45.5762V4H48.4313ZM55.2207 16.3169C56.9368 14.2374 55.7528 10.6517 52.6054 10.4517C47.4871 10.1251 47.0599 16.7501 51.3164 17.5499C52.7553 17.8165 54.3365 17.3766 55.2207 16.3102V16.3169Z",
                fill: "#574FEA"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.8382 4V19.716H13.1404V18.423C11.2745 20.2692 7.90223 20.4092 5.58664 19.1628C4.06539 18.343 3.00876 16.9901 2.63407 15.4438L2.45422 14.564C2.4767 14.2308 2.42424 13.8708 2.45422 13.5443C2.74648 10.0451 6.27607 7.51911 10.1953 8.19894C11.3044 8.39222 12.2561 8.85877 13.013 9.59859V4H15.8382ZM9.0338 10.4317C4.24524 10.645 4.29021 17.3233 8.83896 17.6232C14.4144 17.9898 14.2945 10.1984 9.0338 10.4317Z",
                fill: "#574FEA"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M63.3955 4H60.5403V19.716H63.3955V4Z",
                fill: "#574FEA"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M67.8992 14.7626C67.9816 15.6957 68.4312 16.5688 69.2855 17.1286C70.9267 18.2017 73.6844 17.8818 74.6061 16.1689L76.9667 17.1753C75.5054 20.1079 70.8143 20.7144 67.9366 19.1015C63.3204 16.5088 64.1672 9.5439 69.6003 8.29088C73.8942 7.30446 77.9034 10.257 77.4313 14.1961C77.4088 14.376 77.3714 14.6026 77.2889 14.7626H67.8992ZM74.3888 12.8031C74.2689 10.9102 72.2531 9.8105 70.2372 10.3437C68.9783 10.6769 68.1614 11.67 67.9666 12.8031H74.3963H74.3888Z",
                fill: "#574FEA"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M24.09 8.089C28.9235 8.06234 32.0934 12.1746 30.4223 16.1936C28.2341 21.4656 19.2415 21.1257 17.6453 15.6471C16.5062 11.7414 19.5337 8.10899 24.0975 8.089H24.09ZM23.9326 10.4351C18.9867 10.6817 19.2265 17.9532 24.4797 17.6266C29.2307 17.3267 28.9235 10.1885 23.9326 10.4351Z",
                fill: "#574FEA"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M35.0242 8.354V15.4789C35.0242 16.4186 35.9834 17.3384 36.9801 17.545C38.8311 17.9383 40.3898 16.9185 40.4572 15.2323V8.354H43.3124V19.7178H40.5771V18.4515L40.3149 18.758C37.2874 21.3774 32.4388 19.5912 32.1691 15.8454V8.354H35.0242Z",
                fill: "#574FEA"
            })
        ]
    });
};
